import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SPOwnerPartnerState {
  partners: Array<SPOwnerPartnerTypes>;
}

const initialState: SPOwnerPartnerState = {
  partners: [],
};

export const spOwnerPartnerSlice = createSlice({
  name: "spOwnerPartner",
  initialState,
  reducers: {
    setSpOwnerPartnerData: (
      state,
      { payload }: PayloadAction<SPOwnerPartnerState["partners"]>
    ) => {
      state.partners = payload;
    },
    clearSpOwnerPartner: (state) => {
      state.partners = [];
    },
  },
});

export const { setSpOwnerPartnerData, clearSpOwnerPartner } =
  spOwnerPartnerSlice.actions;
